import { render } from "./FileLayouts.vue?vue&type=template&id=25df1890"
import script from "./FileLayouts.vue?vue&type=script&lang=js"
export * from "./FileLayouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/direct_mail/FileLayouts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25df1890"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25df1890', __exports__)) {
    api.reload('25df1890', __exports__)
  }
  
  module.hot.accept("./FileLayouts.vue?vue&type=template&id=25df1890", () => {
    api.rerender('25df1890', render)
  })

}


export default __exports__